//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
let d=[[[0,"Status",0,0],[0,"StockData",1,"Routing.StockData",0]],[[["stockData"],"RefreshStockData",{R_:{status:''}},1,0]],[]];
SPLM.Routing.StockDataRefreshBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.StockDataRefreshBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.StockDataRefreshBuilder.RefreshStatus = Object.freeze({
    "Ok" : "Ok", "StockDataTagInvalid" : "StockDataTagInvalid", "StockDataMissingSearchAttributes" : "StockDataMissingSearchAttributes", "StockPartNotFoundInReuseLibrary" : "StockPartNotFoundInReuseLibrary", "MultipleStocksFoundInReuseLibrary" : "MultipleStocksFoundInReuseLibrary", "StockPartNotRequired" : "StockPartNotRequired", "StockPartNotFoundForLoading" : "StockPartNotFoundForLoading", "CannotFullyLoadStockPart" : "CannotFullyLoadStockPart", "StockDataNotFoundInLoadedPart" : "StockDataNotFoundInLoadedPart", "StockConversionError" : "StockConversionError", "ErrorRefreshUndone" : "ErrorRefreshUndone"});

export default SPLM;